module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, _vm._l((_vm.categories()), function(category) {
    return _c('div', [_c('h3', [_c('router-link', {
      staticClass: "category",
      attrs: {
        "to": ("/categories/" + (_vm.scrub(category))),
        "active-class": "active",
        "exact": ""
      }
    }, [_c('a', [_vm._v(_vm._s(category))])])], 1), _vm._v(" "), _vm._l((_vm.subCategories(category)), function(subCategory) {
      return _c('h4', {
        staticClass: "subcategories"
      }, [_c('router-link', {
        staticClass: "subCategory",
        attrs: {
          "to": ("/categories/" + (_vm.scrub(category)) + "/" + (_vm.scrub(subCategory))),
          "active-class": "active",
          "exact": ""
        }
      }, [_vm._v("\n        " + _vm._s(subCategory) + "\n      ")])], 1)
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-645e49de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories.vue
// module id = 158
// module chunks = 2